export enum GPSInsightsContainerView {
  All,
  Insight,
}
